import { catchError } from './common';
import axios from 'axios';

export const savePrompt = async (userId: string, prompt: string): Promise<any> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/chat/users/${userId}/prompts`,
      {
        prompt: prompt,
      }
    );
    return response.data.data;
  } catch (e: any) {
    console.error(e);
    catchError(e);
  }
};

export const getSavedPrompts = async (userId: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/chat/users/${userId}/prompts`
    );
    return response.data.data;
  } catch (e: any) {
    console.error(e);
    catchError(e);
  }
};

export const getSamplePrompts = async (): Promise<any> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/chat/prompts/sample`
    );
    return response.data.data;
  } catch (e: any) {
    console.error(e);
    catchError(e);
  }
};

export const deleteSavedPrompts = async (promptId: number): Promise<any> => {
  try {
    const response = await axios.delete(
      `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_VERSION}/ai/chat/prompt/${promptId}`
    );
    return response.data;
  } catch (e: any) {
    console.error(e);
    catchError(e);
  }
};
